import React from 'react';

import Modal from 'components/Modal';
import Text from 'components/Text';

interface ConfirmCancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <Modal
      closeModal={onClose}
      title="Confirmar cancelamento"
      onSecondaryClick={onClose}
      secondaryTextButton="Voltar"
      onPrimaryClick={onConfirm}
      primaryTextButton="Sim, cancelar"
      //   primaryButtonProps={{ variant: 'red', loading: loading }}
    >
      <Text>Você tem certeza que deseja cancelar esta solicitação? Esta ação é irreversível.</Text>
    </Modal>
  );
};

export default ConfirmCancelModal;
